import styled from "styled-components";

export const FooterLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  height: 100%;
`;

export const FooterCol = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

export const EndCol = styled(FooterCol)`
  justify-content: flex-end;
`;
